import { cloneElement, isValidElement } from 'react';

import { useModal } from '../../model/context/useModal';

import type { FC, MouseEventHandler, PropsWithChildren } from 'react';

type ModalTriggerProps = PropsWithChildren;

const ModalTrigger: FC<ModalTriggerProps> = ({ children }) => {
  const { setIsOpen } = useModal();

  if (!isValidElement<{ onClick?: MouseEventHandler }>(children)) return;

  const handleTriggerClick = () => {
    setIsOpen(true);
  };

  return cloneElement(children, {
    onClick: (e) => {
      handleTriggerClick();
      children.props.onClick?.(e);
    },
  });
};

export { ModalTrigger };
